export default "__VITE_ASSET__3r3GevHs__"